export default "__VITE_ASSET__B3pfr3i4__"